
import ImageHeader from '@/components/core/ImageHeader';
import CurrentLoactionHeader from "@/components/core/CurrentLoactionHeader";
import RestaurantCard from "@/components/RestaurantCard";
import CategoryFilter from "@/components/CategorySection/CategoryFilter";
import tableLoading from "@/components/tableLoading";
import NoContent from "@/components/customer-content/NoContent";
export default {
  scrollToTop: true,
  components: {
    ImageHeader,
    CategoryFilter,
    CurrentLoactionHeader,
    tableLoading,
    RestaurantCard,
    NoContent,
  },
  head() {
    return {
      title: this.title,
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "best restaurants in goa, restaurants in goa, top 10 restaurants in goa, famous restaurants in goa, top restaurants in goa, pure veg restaurants in goa",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      ],
    };
  },

  jsonld() {
    return this.getJsonData()
  },

  data() {
    return {
      title: "Best Restaurants in Goa | Dining Experiences, Seafood, & More",
      description: "Discover Best Restaurant in Goa with best dining spots! From beachfront seafood to cozy veg restaurant, find your best restaurant near me. Book a table today!",
      selectedValue: null,
      search: "",
      isSearchClicked: false,
      pageData: {
        categories: null,
        featuredCategories: null,
        activities: null,
      },
      filters: {
        categories: [],
        allCategory: true,
        sortBy: "popular",
      },
      applyFilterClicked: false,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      busy: false,
      productObj: [],
      schemaData: [],
      loading: true,
      listingLoading: true,
      initialLoading: true,
      selectedFilter: -1,
      slickOptions: {
        slidesToShow: 6,
        arrows: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        swipe: true,
        mobileFirst: true,
        touchMove: true,
        waitForAnimate: true,
        focusOnChange: true,
        cssEase: 'ease',
        easing: 'linear',
        useCSS: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4.2,
            slidesToScroll: 1,
            infinite: false,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3.2,
            slidesToScroll: 1,
            infinite: false,
          }
        }, {
          breakpoint: 575,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
            infinite: false,
          }
        }, {
          breakpoint: 375,
          settings: {
            slidesToShow: 2.1,
            slidesToScroll: 1,
            infinite: false,
          }
        }

        ]
      }
    };
  },
  fetchOnServer: false,
  async fetch() {
    //Get the list of page data
    this.pageData.categories = await fetch(
      this.$config.fetchUrl + "/api/activityTypes/app/getTypeDetails/places"
    ).then((res) => res.text());
    this.pageData.categories = this.getCryptKey(this.pageData.categories);
    this.pageData.featuredCategories = await fetch(
      this.$config.fetchUrl +
      "/api/activityCategories/app/getFeaturedCategories"
    ).then((res) => res.text());
    this.pageData.featuredCategories = this.getCryptKey(this.pageData.featuredCategories);
  },

  mounted() {
    document.body.classList.add("modalOverflow");
    if (localStorage.getItem("plcData")) {
      localStorage.removeItem('plcData');
    }

    let searchedCategory = this.$route.query.category ?
      this.$route.query.category :
      null;
    var self = this;
    if (searchedCategory) {
      if (Array.isArray(searchedCategory)) {
        searchedCategory.forEach(function (value, index) {
          self.filters.categories.push(value);
        });
      } else {
        this.filters.categories.push(searchedCategory);
      }
      this.filters.allCategory = false;
    }

    //this.restoreFilters();
    let pagination = (this.page - 1) * 12;
    if (pagination < 0) {
      pagination = 0;
    }

    this.getListings(
      pagination,
      this.search,
      this.filters.sortBy,
      this.filters.categories
    );
  },

  destroyed() {
    document.body.classList.remove("modalOverflow");
    if (document.getElementById("filterClose"))
      document.getElementById("filterClose").click();
    if (document.getElementById("locationClose"))
      document.getElementById("locationClose").click();
  },

  computed: {
    disableSearch() {
      let searchStr = "";
      if (this.search) searchStr = this.search.trim();
      const re = /^[a-zA-Z0-9\s,-]{3,}/;
      return re.test(String(searchStr).toLowerCase());
    },
  },

  methods: {
    getJsonData() {
      let structure = {
        "@context": "http://schema.org"
      }
      let data = this.schemaData.map((itm, index) => ({
        "@type": "LocalBusiness",
        "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
        "image": itm.post && itm.post.gallery ? itm.post.gallery : [],
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": itm.post && itm.post.location ? itm.post.location.latitude : '',
          "longitude": itm.post && itm.post.location ? itm.post.location.longitude : ''
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": itm.post && itm.post.location ? itm.post.location.address : '',
          "addressLocality": "Goa",
          "postalCode": "403001",
          "addressCountry": "IN"
        },
        priceRange: '',
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
            "bestRating": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
          },
          "author": {
            "@type": "Person",
            "name": "GoaApp"
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
          "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : ''
        },
      }))
      return {
        ...structure,
        ...data
      };
    },



    getCatTitles() {
      var titles = "All Places";
      if (this.filters.categories.length < 1) {
        return "All Places";
      } else if (
        this.pageData &&
        this.pageData.categories &&
        this.pageData.categories.categories &&
        this.pageData.categories.categories.length > 0
      ) {
        if (
          this.pageData.categories.categories.length ==
          this.filters.categories.length
        ) {
          return "All Places";
        } else {
          titles = this.pageData.categories.categories.filter((a) =>
            this.filters.categories.some((b) => a._id === b)
          );
          var names = titles.map(function (item) {
            return item["name"];
          });
          return names.join(", ");
        }
      } else return "All Places";
    },

    // Store filters in Localstorage
    restoreFilters() {
      let filters = null;
      if (localStorage.getItem("restaurantsFilter")) {
        filters = JSON.parse(localStorage.getItem("restaurantsFilter"));
        this.search = filters.search;
        this.filters.sortBy = filters.sortBy;
        this.filters.categories = filters.categories;

        if (filters.categories.length > 0) {
          this.filters.allCategory = false;
        }
        this.page = filters.page;
      }
    },

    // Store filters in Localstorage
    storeFilters() {
      let filters = {
        search: this.search,
        sortBy: this.filters.sortBy,
        page: this.page,
        categories: this.filters.categories,
      };
      localStorage.setItem("restaurantsFilter", JSON.stringify(filters));
    },
    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return "";
      }
    },


    categoryAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
    },
    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      this.storeFilters();
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      //this.scrollToElement('listing-list');
      if (
        (this.search && this.isSearchClicked) ||
        (this.filters.sortBy && this.filters.sortBy != "popular") ||
        (this.filters.categories && this.filters.categories.length > 0)
      ) {
        this.getListings(
          pagination,
          this.search,
          this.filters.sortBy,
          this.filters.categories
        );
      } else {
        this.getListings(pagination);
      }
    },
    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, queryStr = null, sortBy = null, categories = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //iF categories array pass the array in params
      //var arrStr = encodeURIComponent(JSON.stringify(this.filters.categories));

      //this.listingLoading = true;
      var formData = new URLSearchParams();
      formData.append("skip", skip);
      if (queryStr) formData.append("query", queryStr.trim());
      if (sortBy) formData.append("sortBy", sortBy.trim());
      if (categories != null && categories.length > 0) {
        categories.forEach((category) => {
          formData.append("categories", category);
        });
      }
      if (categories != null && categories.length > 0) {
        categories = encodeURIComponent(JSON.stringify(categories));
      } else {
        categories = ["all"];
      }

      var query = "search";

      if (queryStr) {
        query = queryStr.trim();
      }

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      this.$axios
        .get(
          `/api/posts/app/getPostsOfType/restaurants/${query}/${skip}/${categories}/${sortBy ? sortBy : "popular"
          }`
        )
        .then((response) => {
          this.applyFilterClicked = false;
          this.initialLoading = false;
          if (queryStr) this.isSearchClicked = true;
          let value = this.getCryptKey(response.data);
          this.listings = value;
          this.productObj.push(...value.posts)
          this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
          if (skip == 0) {
            this.page = 1;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          document.getElementById("filterClose").click();
          this.$nextTick(() => {
            // this.scrollToSectionIntoView("listing-card");
            // window.scrollTo({
            //   top: 0,
            //   behavior: "smooth",
            // });
            this.busy = false;
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        });
    },

    // Hide/Show clear Button
    showClearBtn() {
      if (
        (this.search && this.isSearchClicked) ||
        (this.filters.sortBy && this.filters.sortBy != "popular") ||
        (!this.filters.allCategory && this.filters.categories.length > 0)
      )
        return true;
      return false;
    },

    // Clear all dates, search and filters on click
    clearAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
      this.filters.sortBy = "popular";
      this.search = "";
      this.isSearchClicked = false;
    },
  },
};
